import ERRORS_CONFIG from "@/constants/errors";

class ErrorHandlerService {
  constructor(errors = null, type) {
    this.messages = this.setErrors(errors, type);
    this.hasErrors = !!errors;
  }

  /**
   * Errors always return in view as [request param]:[errors array]
   * @param errors {Object} - errors
   * @param type {string} - name from hardcoded config
   */
  setErrors(errors, type) {
    let config = ERRORS_CONFIG(type);
    if (errors) {
      for (let key in errors) {
        config[key] = errors[key][0];
      }
    }
    return config;
  }

  /**
   * If you need to update errors
   */
  updateErrors(errors, type) {
    this.messages = this.setErrors(errors, type);
  }

  /**
   * Returns error value by name
   * @param name {string} - error name
   */
  getErrorByName(name) {
    return this.messages[name];
  }

  /**
   * Get error key and check, that returns boolean.
   * If check is true, clear error this same name
   *
   * @param name {string} - error key
   * @param check {boolean} - check that error is fix
   * @returns {boolean}
   */
  checkErrorIsFixed(name, check) {
    if (check) {
      this.messages[name] = "";
    }
    return !this.messages[name];
  }
}
export default ErrorHandlerService;
